import { useContext, useEffect, useState } from 'react';

import { getColorEmoji } from '@/const/color';
import { GameContext } from '@/state/contexts';
import { performActionType } from '@/type/performAction';
import { cardPurchaseRequiresDecision } from '@/util/card';
import { donateEnergy, playCard, playSummitCard } from '@lc/const/socketEvent';
import { createActionParams } from '@lc/interface/actionParams/factory';

import EmojiBucket from './EmojiBucket';

import '@/style/HandModal.css';

// TODO Don't immediately pay for card if it has conditions for a DECISION.
// IF DECISION, GOTO DECISION MODAL TO ENHANCE DATA TO BE SENT TO SERVER VIA SOCKET EMMISSION

// char + integer selection field with upper bound of amnt energy and lower bound of 0.
/**
 * For every char in fArr and bArr, tally up how much I have of each, create an html label and selector with 0 floor and num ceil
 * each time selector is updated, update payment tally with object of energy to be used for payment
 *
 * function to process how much
 *
 * for each energy on factoryEnergyArr, create a dropdown with 0 floor, and numEnergy Ceil
 * same for batteryEnergyArr
 * carbon is just a num
 *
 * each update of selection hits a function to transform the paymentObj
 */

const PaymentAnimatedModal = ({
	onClose,
	requestClientDecision,
	resetPaymentObject,
}) => {
	const {
		currPlayer,
		myState,
		selectedAction,
		selectedActionCost,
		selectedCard,
		selectedCardId, // TODO selectedCard will determine price, source and target, decisions. Replace w/ cardId

		setPaymentTotal,
		paymentTotal,
		setPaymentObject,
		paymentObject,

		performAction,

		// setFArr,
		// fArr,
		// setBArr,
		// bArr,
	}: any = useContext(GameContext);

	const performActionTyped = performAction as performActionType;

	const [fArr, setFArr] = useState([...myState.factoryEnergyArr]);
	const [bArr, setBArr] = useState([...myState.batteryEnergyArr]);
	const [cArr, setCArr]: any = useState([]);

	const [paymentArr, setPaymentArr]: any = useState([]);

	function setCarbonArray() {
		let carbonArr: string[] = [];
		for (let i = 0; i < myState.carbonReserve; i++) {
			carbonArr.push('c');
		}

		setCArr(carbonArr);
	}

	function fullPaymentReset() {
		setFArr([...myState.factoryEnergyArr]);
		setBArr([...myState.batteryEnergyArr]);
		setCarbonArray();

		resetPaymentObject();
		setPaymentArr([]);
	}

	useEffect(() => {
		resetPaymentObject();
		setCarbonArray();
	}, []);

	function updatePayment(newTally, color = 'c') {
		setPaymentObject(newTally);
		setPaymentTotal(paymentTotal + 1);
		setPaymentArr([...paymentArr, getColorEmoji(color)]);
	}

	function updatePaymentTallyFactory(e, color) {
		e.preventDefault();
		// remove 1 instance of selected color from fArr
		let tempArr = fArr;
		const index = tempArr.indexOf(color);
		if (index < 0) {
			return;
		}
		tempArr.splice(index, 1);
		setFArr(tempArr);

		let newTally = paymentObject;
		newTally.factoryEnergyArr.push(color);
		updatePayment(newTally, color);
	}

	function updatePaymentTallyBattery(e, color) {
		e.preventDefault();
		// remove 1 instance of selected color from bArr
		let tempArr = bArr;
		const index = tempArr.indexOf(color);
		if (index < 0) {
			return;
		}
		tempArr.splice(index, 1);
		setBArr(tempArr);

		let newTally = paymentObject;
		newTally.batteryEnergyArr.push(color);
		updatePayment(newTally, color);
	}

	function updatePaymentTallyCarbon(e) {
		e.preventDefault();
		if (cArr.length <= 0) {
			return;
		}

		let tmpCArr = cArr;
		tmpCArr.pop();
		setCArr(tmpCArr);

		let newTally = paymentObject;
		newTally.carbonReserve += 1;
		updatePayment(newTally, 'c');
	}

	// TODO check if cardId if playCard has a decision, if so GOTO DecisionModal
	function closeModalWithPay() {
		let makeDecision = false;

		if (selectedAction === playCard || selectedAction === playSummitCard) {
			// determine if card needs decision here
			makeDecision = cardPurchaseRequiresDecision(selectedCardId);

			const actionParams = createActionParams(
				selectedCardId,
				paymentObject
			);

			if (!makeDecision) {
				performActionTyped(selectedAction, actionParams);
			}
		} else if (
			selectedActionCost === paymentTotal ||
			selectedAction === donateEnergy
		) {
			const actionParams = createActionParams(-1, paymentObject);

			performActionTyped(selectedAction, actionParams);
		} else {
			alert('Incorrect payment');
		}

		if (makeDecision) {
			requestClientDecision(); // close PaymentModal and goto DecisionModal
			return;
		}

		onClose();
	}

	// Pay button should close the modal and send the socket call
	// TODO determine if card has special cases to change payment modal
	// IF no cost, no target, just play when button is pressed
	// IF requires target, source, both, use payment modal regardless whether payment is necessary
	return (
		<div className="modal" onClick={onClose}>
			<div className="modal-content" onClick={(e) => e.stopPropagation()}>
				<span className="close" onClick={onClose}>
					&times;
				</span>
				<h2 className="modal-title">Payment for: {selectedAction}</h2>
				{selectedActionCost > 0 && (
					<div className="energy-container">
						{fArr.length > 0 && (
							<>
								<div>Factory:</div>
								<div className="energy-array">
									{fArr.map((color) => {
										return (
											<div className="energy-singular">
												<p>{getColorEmoji(color)}</p>
												<button
													onClick={(e) =>
														updatePaymentTallyFactory(
															e,
															color
														)
													}
												>
													Add
												</button>
											</div>
										);
									})}
								</div>
							</>
						)}
						{bArr.length > 0 && (
							<>
								<div>Battery:</div>
								<div className="energy-array">
									{bArr.map((color) => {
										return (
											<div className="energy-singular">
												<p>{getColorEmoji(color)}</p>
												<button
													onClick={(e) =>
														updatePaymentTallyBattery(
															e,
															color
														)
													}
												>
													Add
												</button>
											</div>
										);
									})}
								</div>
							</>
						)}

						{selectedAction !== donateEnergy && cArr.length > 0 && (
							<>
								<div>Carbon:</div>
								<div className="energy-array">
									{cArr.map((color) => {
										return (
											<div className="energy-singular">
												<p>{getColorEmoji(color)}</p>
												<button
													onClick={(e) =>
														updatePaymentTallyCarbon(
															e
														)
													}
												>
													Add
												</button>
											</div>
										);
									})}
								</div>
							</>
						)}
					</div>
				)}
				{selectedAction === donateEnergy ? (
					<div>Selected: {paymentTotal}</div>
				) : (
					<div>
						Cost: {selectedActionCost} Selected: {paymentTotal}
					</div>
				)}
				<EmojiBucket paymentArr={paymentArr} />

				<div className="modal-reset-play">
					<button onClick={(e) => fullPaymentReset()}>Reset</button>
					<button onClick={(e) => closeModalWithPay()}>
						{selectedActionCost === 0 ? 'Play' : 'Pay'}
					</button>
				</div>
			</div>
		</div>
	);
};

export default PaymentAnimatedModal;
